<ion-header *transloco="let t">
  <ion-toolbar class="telus-header">
    <ion-title>
      {{ t(pageType + '.modalTitle') }}
    </ion-title>

    <ion-buttons slot="primary">
      <ion-button (click)="closeModal()">
        {{ t(pageType + '.cancelButton') }}
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        (click)="applyChanges()"
        class="telus-back-button"
        color="primary"
        data-testid="save-button"
      >
        {{ t(pageType + '.submitButton') }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form *transloco="let t" class="p-4">
    <ion-row>
      <ion-col size="12">
        <ion-item *ngIf="dataConfig?.editType === 'text'">
          <ion-input
            inputmode="text"
            name="inputValue"
            [(ngModel)]="dataConfig.value"
            placeholder="Enter more information here..."
            class="form-input-item-editable"
            data-testid="form-input-item-editable"
          ></ion-input>
        </ion-item>
        <ion-item *ngIf="dataConfig?.editType === 'longtext'">
          <ion-textarea
            [(ngModel)]="dataConfig.value"
            name="inputValue"
            placeholder="Enter more information here..."
          ></ion-textarea>
        </ion-item>
        <telus-dropdown
          [items]="dropdownData$ | async"
          [defaultText]="'Select'"
          (selectedAction)="onDropdownSelection($event)"
          data-testid="cy-dropdown-item"
        ></telus-dropdown>
      </ion-col>
    </ion-row>
  </form>
</ion-content>
